import styled from 'styled-components';

const TableHead = styled.thead`
  height: ${(props) => props.height};
  background-color: ${(props) => props.backgroundColor};
`;

export default TableHead;
